<template>
  <div id="app">
    <nav-bar
      :brandName="marketBrand"
      :brandHref="anonMarket ? $router.resolve({name: 'user-login', params: { marketId: anonMarket.marketId }}).location : $router.resolve({name: 'base'}).location" />
    <router-view/>
    <custom-footer />
  </div>
</template>

<script>
  import NavBar from '@base/components/NavBar.vue'
  import CustomFooter from '@base/components/CustomFooter.vue'
  import { mapState } from "vuex";
  import { APP_NAME } from "@base/configs";

  export default {
    name: 'Base',

    components: {
      NavBar,
      CustomFooter
    },

    data () {
      return {
      }
    },

    created () {
      this.$store.commit(this.$_mutationTypes.SET_LOADER, false)
    },

    computed: {
      ...mapState(['anonMarket']),

      marketBrand () {
        return (this.anonMarket?.visualName) ?
          this.anonMarket.visualName : this.$t('title.home.company', { appName: APP_NAME })
      }
    },
  }
</script>

<style>

</style>
